import React, { useState } from 'react';
import { isEmpty } from 'lodash';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { injectIntl, IntlShape } from 'react-intl';
import messages from 'containers/LawyerLegalProceedingsPage/judgementAdd/JudgementAddPronouncing/messages';
import { translate } from 'containers/services/translate';
import { Wrapper } from 'containers/LawyerLegalProceedingsPage/judgementAdd/JudgementAddPronouncing/styled-components';
import JudgementAddForms from 'containers/LawyerLegalProceedingsPage/judgementAdd/JudgementAddPronouncing/JudgementAddForms';
import { Listings } from 'containers/AppContainer/typings';
import { Vehicule } from 'containers/PreOpeningPage/typings';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import { JudgementADDDocumentType } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import EmptyAddFormBloc from 'components/EmptyAddFormBloc';
import { VictimType } from 'typings/globalTypes';

export interface JudgementAddPronouncingProps {
  intl: IntlShape;
  listings: Listings;
  setJudgementAddDocuments: Function;
  judgementAddDocuments: JudgementADDDocumentType[];
  victims: VictimType[];
  vehicules: Vehicule[];
  uploadDocument: Function;
  uploadedDocument: IUploadedDocument;
  resetUploadedDocument: Function;
  disabled: boolean;
  details: any;
  judiciaryProcessId?: number;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  claimAssignment?: any;
  feeNotes?: any;
  isBasicManagement?: boolean;
  imagineDocuments: any;
  policyInfo: any;
  claimId: number;
  requestGetDocByDocumentumId: Function;
}

const JudgementAddPronouncing: React.FC<JudgementAddPronouncingProps> = (
  props,
): JSX.Element => {
  const [isAddJudgementAddFormOn, setIsAddJudgementAddFormOn] = useState<
    boolean
  >(
    !isEmpty(props.judgementAddDocuments) && props.isBasicManagement
      ? true
      : false,
  );

  const handleAddButton = () => {
    setIsAddJudgementAddFormOn(true);
  };

  return (
    <Wrapper>
      <section className="content">
        <div className="pronounce-add-bloc-title">
          {translate(messages.judgementAddPronouncingTitle, props)}
        </div>
        {!isAddJudgementAddFormOn && (
          <EmptyAddFormBloc
            title={translate(messages.judgementAddPronouncingSubtitle, props)}
            buttonBlocTitle={translate(
              messages.judgementAddPronouncingButtonTitle,
              props,
            )}
            icon={<AddCircleOutlineIcon className="icon" />}
            handleClick={handleAddButton}
          />
        )}

        {isAddJudgementAddFormOn && (
          <JudgementAddForms
            listings={props.listings}
            details={props.details}
            judgementAddDocuments={props.judgementAddDocuments}
            setJudgementAddDocuments={props.setJudgementAddDocuments}
            victims={props.victims}
            vehicules={props.vehicules}
            uploadDocument={props.uploadDocument}
            uploadedDocument={props.uploadedDocument}
            resetUploadedDocument={props.resetUploadedDocument}
            setIsAddJudgementAddFormOn={setIsAddJudgementAddFormOn}
            judiciaryProcessId={props.judiciaryProcessId}
            sagisVictimInfo={props.sagisVictimInfo}
            sagisOpposingParties={props.sagisOpposingParties}
            claimAssignment={props.claimAssignment}
            feeNotes={props.feeNotes}
            isBasicManagement={props.isBasicManagement}
            imagineDocuments={props.imagineDocuments}
            policyInfo={props.policyInfo}
            claimId={props.claimId}
            requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
          />
        )}
      </section>
    </Wrapper>
  );
};

export default injectIntl(JudgementAddPronouncing);
